// Import dependencies
import initialiser from '../../utils/initialiser';
import { addClass, removeClass } from '../../utils';

class VideoModal {
  constructor(config) {
    const { el, settings } = config;

    // Set module dom elements
    this.container = el;
    this.button = el.querySelector(settings.modalButton);
    this.modalId = this.button.getAttribute(settings.modalIdAttr);
    this.videoType = this.button.getAttribute(settings.videoTypeAttr);
    this.videoId = this.button.getAttribute(settings.videoIdAttr);
    this.modal = document.getElementById(this.modalId);
    this.closeButton = this.modal.querySelector(settings.closeButton);
    this.modalInner = this.modal.querySelector(settings.modalInner);
    this.videoFrame = this.modal.querySelector('iframe');
    this.loader = this.modal.querySelector(settings.loader);
    this.youtubeVideoSrc = `https://www.youtube.com/embed/${this.videoId}?rel=0&amp;showinfo=0&amp;modestbranding=1`;
    this.brightcoveVideoSrc = `
      https://players.brightcove.net/5791559000001/default_default/index.html?videoId=${this.videoId}
    `;

    // Set settings
    this.settings = settings;
  }

  // Initialisation Function
  init = () => {
    if (!this.container || !this.button || !this.modalId || !this.modal) return;

    this.button.addEventListener('click', this.toggleModal);
    this.modal.addEventListener('click', this.handleBodyClick);
    document.addEventListener('keyup', this.handleKeyUp);

    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.closeModal);
    }
  };

  handleKeyUp = (e) => {
    if (e.key === 'Escape' || e.keyCode === 27) {
      this.closeModal(e);
    }
  };

  toggleModal = (e) => {
    e.preventDefault();
    this.modal.classList.toggle(this.settings.modalOpen);
    document.body.classList.toggle(this.settings.showOverlay);
    addClass(this.loader, this.settings.modalOpen);

    if (this.videoId) this.showVideo();

    // Hide loader once iframe/video frame is loaded
    setTimeout(() => {
      removeClass(this.loader, this.settings.modalOpen);
    }, 2000);
  };

  closeModal = (e) => {
    e.preventDefault();
    removeClass(this.modal, this.settings.modalOpen);
    removeClass(document.body, this.settings.showOverlay);
    removeClass(this.loader, this.settings.modalOpen);

    if (this.videoId) this.hideVideo();
  };

  handleBodyClick = (e) => {
    // if the overlay is clicked, close the modal
    if (!this.modalInner.contains(e.target)) {
      this.closeModal(e);
    }
  };

  hideVideo = () => {
    const videoSource = this.videoFrame.getAttribute('src');

    if (videoSource) {
      setTimeout(() => {
        this.videoFrame.setAttribute('src', '');
        removeClass(this.videoFrame, this.settings.modalOpen);
      }, 300);
    }
  };

  showVideo = () => {
    if (this.videoType === 'youtube') {
      addClass(this.videoFrame, this.settings.modalOpen);
      this.videoFrame.setAttribute('src', this.youtubeVideoSrc);
    } else if (this.videoType === 'brightcove') {
      addClass(this.videoFrame, this.settings.modalOpen);
      this.videoFrame.setAttribute('src', this.brightcoveVideoSrc);
    }
  };
}

export default (settings) => initialiser(settings, VideoModal);
